import {lazyRegister} from '@/Core/lazyRegister';
import './sidebar-menu.component.css';
import template from './sidebar-menu.component.html';
import './sidebar-item/sidebar-item.component';
import {SideBarMenuItem} from "./sidebar-item/SideBarMenuItem";

class SidebarMenuController {
    static $inject = ['$element'];

    public items: SideBarMenuItem[] = [];
    public selectedItemId: string;
    public onTabChange: Function;

    constructor(private $element) {
    }

    $onInit(): void {
        this.$element.addClass('sidebar-menu');
        this.items.sort((a, b) => (a.order || 0) - (b.order || 0));
    }

    handleTabChange($tab) {
        if (this.onTabChange) {
            this.onTabChange({$tab: $tab || this.selectedItemId});
        }
    }
}

export const SidebarMenuComponent: ng.IComponentOptions = {
    transclude: true,
    bindings: {
        items: '<',
        selectedItemId: '=',
        onTabChange: '&?'
    },
    template: template,
    controller: SidebarMenuController
};

lazyRegister.component('sidebarMenu', SidebarMenuComponent);